import { derived } from 'svelte/store';
import type { ProductCmsAccessSummary } from '$lib/api/modules-access';
import { loadModulesAccess, modulesAccess, modulesAccessState, resetModulesAccess } from './modulesAccess';

export type { ProductCmsAccessSummary } from '$lib/api/modules-access';

export const productCmsAccess = derived(modulesAccess, ($modulesAccess) => $modulesAccess.productCms);
export const isLoadingProductCmsAccess = derived(modulesAccessState, ($state) => $state.status === 'refreshing');

export async function loadProductCmsAccess(force = false): Promise<void> {
  await loadModulesAccess(force);
}

export function resetProductCmsAccess(): void {
  resetModulesAccess();
}
